import React from 'react';
import Hero from "./Hero"
import Team from "./Team"

function About() {
    return ( 
        <>
            <Hero />
            <Team />        
        </>
     );
}

export default About;